import { render } from "./throttle.vue?vue&type=template&id=45695243"
import script from "./throttle.vue?vue&type=script&lang=js"
export * from "./throttle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__